import { PropTypes } from 'prop-types'
import { grantedRightLevelPropType } from './granted-right-level-prop-type'

/**
 * @typedef {Object} UserRightLevels
 * @property {string} [profileId] - The ID of the right profile that the user should be assigned to. The profile
 *   defines which right levels can be granted to a user.
 * @property {Array<GrantedRightLevel>} [grantedRightLevels] - The list of WEBFLEET right levels a user has been
 *   granted. The right levels must refer to the available right levels defined by the given profile.
 */
export const userRightLevelsPropType = PropTypes.shape({
    grantedRightLevels: PropTypes.arrayOf(grantedRightLevelPropType),
    profileId: PropTypes.string
})
